import { Tooltip } from "@mui/material";
import { ErrorMessage } from "formik";
import React from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { getInputHeight } from "src/utils/formUtils/getInputHeight";

export type ATMTextFieldPropTypes = {
  name?: string;
  value?: string | string[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  size?: "small" | "medium" | "large";
  showInfo?: boolean
  tooltipInfoTitle?: string
} & Omit<React.ComponentProps<"input">, "size">;

const ATMTextField = ({
  name,
  value,
  className = "bg-white rounded",
  onChange,
  label,
  required,
  size = "small",
  showInfo = false,
  tooltipInfoTitle,
  ...rest
}: ATMTextFieldPropTypes) => {
  return (
    <div className="relative">
      <div className="flex items-center gap-1">
        {label && (
          <label className="font-medium text-slate-700">
            {" "}
            {label} {required && <span className="text-red-500"> * </span>}{" "}
          </label>
        )}
        {showInfo &&
          <Tooltip title={tooltipInfoTitle} className="bg-white">
            <div
              className="cursor-pointer"> <BsInfoCircleFill className="text-blue-400" /></div>
          </Tooltip>
        }
       </div>
      <input
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e);
        }}
        className={`${getInputHeight(
          size
        )} w-full px-2 text-slate-700 border border-divider outline-blue-400 mt-1  ${label && "mt-0"
          }  ${className}`}
        {...rest}
      />
      {name && (
        <ErrorMessage name={name}>
          {(errMsg) => (
            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
              {" "}
              {errMsg}{" "}
            </p>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default ATMTextField;
